import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { ISelectItem } from '@mg-platform/core/core-ui'
import { MenuPositionX } from '@angular/material/menu'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { DropdownBottomSheetComponent } from '../dropdown-bottom-sheet/dropdown-bottom-sheet.component'

@UntilDestroy()
@Component({
  selector: 'mg-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  standalone: false
})
export class DropdownMenuComponent implements OnChanges, AfterViewInit {
  @Input() selectedItem?: any
  @Input() placeHolder: string
  @Input() disable = false
  @Input() fullWidth = false
  @Input() items: ISelectItem[] = []
  @Input() extraClass?: string
  @Input() extraLabelClass?: string
  @Input() extraItemClass = ''
  @Input() icon = 'arrow-down-simple'
  @Input() selectedItemPrefix?: string
  @Input() xPosition: MenuPositionX = 'after'
  @Input() bottomSheet = false
  @Input() bottomSheetTitle = 'Sort by'
  @Input() clearable = false

  @Output() selectedItemChanged = new EventEmitter<any>()

  @ViewChild('parentContainer', { static: true }) parentContainer!: ElementRef<HTMLDivElement>

  selectedItemLabel?: string
  menuWidth: number | 'auto' = 'auto'

  constructor(private bottomSheetService: MatBottomSheet) {}

  ngOnChanges(changes: SimpleChanges): void {
    const itemValue = changes['selectedItem']?.currentValue
    if (itemValue) {
      this.selectedItemLabel = this.items.find((el) => el.value === itemValue)?.label
    }
  }

  ngAfterViewInit(): void {
    this.calculateMenuWidth()
  }

  onMenuOpened(): void {
    this.calculateMenuWidth()
  }

  private calculateMenuWidth(): void {
    if (this.fullWidth && this.parentContainer?.nativeElement) {
      // Use setTimeout to ensure the calculation happens after the current change detection cycle
      setTimeout(() => {
        this.menuWidth = this.parentContainer.nativeElement.clientWidth
      })
    } else {
      this.menuWidth = 'auto'
    }
  }

  openBottomSheet() {
    const bottomSheetRef = this.bottomSheetService.open(DropdownBottomSheetComponent, {
      data: {
        items: this.items,
        selectedItem: this.selectedItem,
        extraItemClass: this.extraItemClass,
        title: this.bottomSheetTitle
      }
    })

    bottomSheetRef
      .afterDismissed()
      .pipe(untilDestroyed(this))
      .subscribe((value) => {
        if (value !== undefined) {
          this.selectedItemChanged.emit(value)
        }
      })
  }

  clearSelectedItem(event: MouseEvent) {
    event.stopPropagation()
    this.selectedItemChanged.emit(undefined)
    this.selectedItemLabel = undefined
  }
}
